<template>
  <section
    class="canvas bg-white"
    :class="{
      unlimited: !limitPresets,
    }"
    :style="{
      '--primary-color': settings.primaryColor,
      '--secondary-color': settings.secondaryColor,
      '--promo-color': settings.promotionColor,
      '--font-heading': headingFont,
      '--font-body': bodyFont,
    }"
  >
    <component
      :is="'style'"
      v-if="scopedCss"
    >
      {{ scopedCss }}
    </component>
    <div
      ref="container"
      class="modulos-wrapper canvas__page"
    >
      <EditableInstance
        v-for="instanceId in instanceList"
        :key="instanceId"
        :instance-id="instanceId"
      />
    </div>
    <AddComponent v-show="!limitPresets" />
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import AddComponent from '@/components/guideElements/AddComponent.vue';
import sanitizeCss from '@/helpers/sanitizeCss';
import EditableInstance from './EditableInstance.vue';

export default {
  name: 'Canvas',
  components: {
    EditableInstance,
    AddComponent,
  },
  data() {
    return {
      destroyWatcher: null,
    };
  },
  computed: {
    instanceList() {
      return this.container.instanceList || [this.container.id];
    },
    limitPresets() {
      return this.container.type !== 'pages' && this.instanceList.length >= 1;
    },
    propertiesIsOpen() {
      return this.activeInstance !== null || this.showValidationPanel;
    },
    headingFont() {
      const { pageHeadingFont, headingFont } = this.settings;
      const isGlobalFont = !pageHeadingFont || pageHeadingFont === 'global';
      return isGlobalFont ? headingFont : pageHeadingFont;
    },
    bodyFont() {
      const { pageBodyFont, bodyFont } = this.settings;
      const isGlobalFont = !pageBodyFont || pageBodyFont === 'global';
      return isGlobalFont ? bodyFont : pageBodyFont;
    },
    scopedCss() {
      return sanitizeCss(this.settings.css, '.instance-wrapper');
    },
    ...mapState([
      'activeInstance',
      'showPresetsContent',
      'showValidationPanel',
    ]),
    ...mapGetters(['settings', 'container']),
  },
  mounted() {
    this.destroyWatcher = this.$store.subscribeAction({
      after: (action) => {
        if (action.type === 'addInstanceToActiveContainer') {
          setTimeout(() => {
            if (action.payload.index === null) {
              this.$refs.container.lastChild.scrollIntoView();
            }
          }, 200);
        }
      },
    });
  },
  beforeDestroy() {
    this.destroyWatcher();
  },
};
</script>

<style lang="scss">
@import '@/styles/base/_all';
</style>

<style scoped lang="scss">
.canvas {
  box-shadow: 4px 4px 25px rgba($lb-black, 0.25);

  ::v-deep {
    [data-module] {
      font-family: $lb-content-font;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-family: $lb-heading-font;
      }
    }

    [data-module='banner-with-menu'].no-banners [data-module='header'] {
      position: static !important;
    }

    [data-module='menu'] {
      position: static !important;
    }

    [data-module='widget'],
    [data-module='widget-light'] {
      min-height: 100px;
    }
  }

  &.unlimited {
    min-height: calc(100vh - 140px);
  }

  &__page {
    position: relative;
    z-index: 1;
  }
}
</style>
